module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/FqAZLln006csgiM22gusw-df5429b2f40c9f1fc0347def4a8f3664.jpg";